// The customer behind a requirement is always a Zoho CRM Account - the
// HortiHub organization is only a portal wrapper, and most customers will
// never have one. So the name links to the CRM record, not to nothing.

const CRM_ORG = "org60064861688"; // ManBhawan's Zoho CRM, crm.zoho.in

export const crmAccountUrl = (zohoAccountId) => (zohoAccountId ? `https://crm.zoho.in/crm/${CRM_ORG}/tab/Accounts/${zohoAccountId}` : null);

const CrmAccountLink = ({ zohoAccountId, children }) => {
  const url = crmAccountUrl(zohoAccountId);
  if (!url) return <>{children}</>;
  return (
    <a href={url} target="_blank" rel="noreferrer" title="Open the account in Zoho CRM">
      {children}
    </a>
  );
};

export default CrmAccountLink;
